// Generated using scripts/write-decode-map.ts
/** Packed XML decode trie data. */
export const xmlDecodeTree = /* #__PURE__ */ new Uint16Array([
    512, 26_465, 29_036, 7, 0, 2, 4, 116, 24_638, 116, 24_636, 8693, 29_807,
    24_610, 621, 1, 0, 0, 3, 112, 24_614, 111, 115, 24_615,
]);
//# sourceMappingURL=decode-data-xml.js.map